import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';

class NgxSiMarkdownComponent {
    constructor(element, viewContainerRef) {
        this.element = element;
        this.viewContainerRef = viewContainerRef;
        this.preventExternalLinks = false;
        this.mdEvent = new EventEmitter();
        this.markdown2HTML = (text) => {
            let orderListLevel = 0;
            let unorderedListLevel = 0;
            const checkOrderedListLevel = (expected, line) => {
                while (orderListLevel < expected) {
                    line = `<ol>${line}`;
                    orderListLevel++;
                }
                while (orderListLevel > expected) {
                    line = `</ol>${line}`;
                    orderListLevel--;
                }
                return line;
            };
            const checkUnorderedListLevel = (expected, line) => {
                while (unorderedListLevel < expected) {
                    line = `<ul>${line}`;
                    unorderedListLevel++;
                }
                while (unorderedListLevel > expected) {
                    line = `</ul>${line}`;
                    unorderedListLevel--;
                }
                return line;
            };
            const lines = text.split("\n").map(line => {
                line = line.trimStart();
                // Headlines
                line = line.replace(/^###### (.*)/g, "<h6>$1</h6>");
                line = line.replace(/^##### (.*)/g, "<h5>$1</h5>");
                line = line.replace(/^#### (.*)/g, "<h4>$1</h4>");
                line = line.replace(/^### (.*)/g, "<h3>$1</h3>");
                line = line.replace(/^## (.*)/g, "<h2>$1</h2>");
                line = line.replace(/^# (.*)/g, "<h1>$1</h1>");
                // Bold
                line = line.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
                line = line.replace(/__(.*?)__/g, "<b>$1</b>");
                // Italics
                line = line.replace(/\*(.*?)\*/g, "<i>$1</i>");
                line = line.replace(/_(.*?)_/g, "<i>$1</i>");
                // Unordered list items
                if (orderListLevel === 0) {
                    line = line.replace(/^[-+*] (.*)/g, "<li>$1</li>");
                    line = line.replace(/^  [-+*] (.*)/g, "  <li>$1</li>");
                    if (line.startsWith("<li>")) {
                        line = checkUnorderedListLevel(1, line);
                    }
                    else if (line.startsWith("  <li>")) {
                        line = checkUnorderedListLevel(2, line);
                    }
                    else {
                        line = checkUnorderedListLevel(0, line);
                    }
                }
                // Order list items
                if (unorderedListLevel === 0) {
                    line = line.replace(/^[0-9]+\. (.*)/g, "<li>$1</li>");
                    line = line.replace(/^  [0-9]+\. (.*)/g, "  <li>$1</li>");
                    if (line.startsWith("<li>")) {
                        line = checkOrderedListLevel(1, line);
                    }
                    else if (line.startsWith("  <li>")) {
                        line = checkOrderedListLevel(2, line);
                    }
                    else {
                        line = checkOrderedListLevel(0, line);
                    }
                }
                // Links
                const linkReg = /\[(.+)\]\((\S+)(?:\s\"?(.*)\")?\)/;
                const linkRes = line.match(linkReg);
                if (linkRes != null) {
                    const title = linkRes[3] != null ? ` title="${linkRes[3]}" ` : "";
                    line = line.replace(linkRes[0], `<a href='${linkRes[2]}' ${title}>${linkRes[1]}</a>`);
                }
                // Paragraph
                if (line.length === 0) {
                    line = "<p>";
                }
                // // Encapsulate list elements in unnumbered list tags
                // if (line.startsWith("<li>") && !unorderedListHasStarted) {
                //   unorderedListHasStarted = true
                //   line = `<ul>${line}`
                // } else if (!line.startsWith("<li>") && unorderedListHasStarted) {
                //   unorderedListHasStarted = false
                //   line = `${line}</ul>`
                // }
                if (line.endsWith("  ")) {
                    line += "<br>";
                }
                return line;
            });
            return lines.join("\n");
        };
    }
    ngOnChanges() {
        this.innerHTML = this.markdown2HTML(this.text ?? "");
    }
    processClick(event) {
        switch (event.target?.nodeName) {
            case "A":
                {
                    event.stopPropagation();
                    const href = event.target.href;
                    if (this.preventExternalLinks === true ||
                        href.startsWith(window.origin)) {
                        event.preventDefault();
                    }
                    this.mdEvent.next({
                        type: "LINK_CLICKED",
                        link: href.startsWith(window.origin) ? href.slice(window.origin.length + 1) : href
                    });
                }
                break;
            default:
                break;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.1", ngImport: i0, type: NgxSiMarkdownComponent, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.1", type: NgxSiMarkdownComponent, selector: "ngx-si-markdown", inputs: { text: "text", preventExternalLinks: "preventExternalLinks" }, outputs: { mdEvent: "mdEvent" }, usesOnChanges: true, ngImport: i0, template: "<div [innerHtml]=\"innerHTML\" (click)=\"processClick($event)\"></div>\n", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.1", ngImport: i0, type: NgxSiMarkdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-si-markdown', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [innerHtml]=\"innerHTML\" (click)=\"processClick($event)\"></div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }]; }, propDecorators: { text: [{
                type: Input
            }], preventExternalLinks: [{
                type: Input
            }], mdEvent: [{
                type: Output
            }] } });

class NgxSiMarkdownModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.1", ngImport: i0, type: NgxSiMarkdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.1", ngImport: i0, type: NgxSiMarkdownModule, declarations: [NgxSiMarkdownComponent], exports: [NgxSiMarkdownComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.1", ngImport: i0, type: NgxSiMarkdownModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.1", ngImport: i0, type: NgxSiMarkdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NgxSiMarkdownComponent
                    ],
                    imports: [],
                    exports: [
                        NgxSiMarkdownComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of ngx-si-markdown
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSiMarkdownComponent, NgxSiMarkdownModule };
